import { TThunkAction } from '../../types/redux';
import { fetchBuildersProjects } from '../buildersProjects';

export const changePage = (page: number): TThunkAction<Promise<void>> => {
  return async (dispatch, getState) => {
    const {
      filters: { appliedFilters },
    } = getState();

    await dispatch(fetchBuildersProjects({ filters: appliedFilters, page }));
  };
};
